import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-hot-toast";
import { BiLoaderCircle } from "react-icons/bi";
import { FiUploadCloud } from "react-icons/fi";
import { baseURL } from "../configs/axiosConfig";

// {
//   setImage, image;
// }
const Uploader = ({ refreshFunction, previewImage }) => {
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [avatar, setAvatar] = useState(null);

  const uploadS3Image = async (file) => {
    if (
      !file ||
      !["image/jpeg", "image/jpg", "image/png"].includes(file.type)
    ) {
      return toast.error("Invalid image format. Only jpg, jpeg, png allowed.");
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${baseURL}/api/products/uploadImageS3`, true);

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100,
          );
          setUploadProgress(percentComplete);
        }
      });

      // Handle success
      xhr.onload = async () => {
        setIsUploading(false);
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          if (res.success) {
            setImagePreview(res.location); // Preview image URL from S3 response
            setAvatar(file);
            refreshFunction && refreshFunction(res.location);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Failed to upload image");
          }
        } else {
          toast.error("Failed to upload image");
        }
      };

      // Handle error
      xhr.onerror = () => {
        toast.error("Failed to upload image");
        setIsUploading(false);
      };

      // Send request
      xhr.send(formData);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong 1");
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatar(file);
    uploadS3Image(file);
  };

  // upload file
  const onDrop = useCallback(async (acceptedFiles) => {
    toast.error("This feature is not available yet");
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop,
  });

  return (
    <div className="w-full text-center grid grid-cols-12 gap-4">
      <div className="lg:col-span-2 sm:col-span-4 col-span-12">
        {isUploading ? (
          <div className="flex flex-col items-center justify-center h-36 gap-2">
            <p>Uploading....</p>
            <div className="w-full bg-gray-300 h-1 rounded-md overflow-hidden">
              <div
                className="h-full bg-yellow-700 transition-all"
                style={{ width: `${uploadProgress}%` }}
              />
            </div>
          </div>
        ) : (
          <img
            src={imagePreview || previewImage || "/images/diamond_logo2.png"}
            alt="preview"
            className=" w-36 h-36 rounded-xl object-cover p-1 m-auto"
          />
        )}
      </div>
      <div className="px-6 lg:col-span-10 sm:col-span-8 col-span-12 pt-0 pb-6 border-2 border-yellowlight border-dashed rounded-md cursor-pointer">
        <label className="cursor-pointer px-4 py-2 text-white rounded-md transition duration-300 ease-in-out">
          <span className="mx-auto flex justify-center">
            <FiUploadCloud className="text-3xl text-subMain" />
          </span>
          <input
            type="file"
            name="photo"
            accept="image/jpeg,image/jpg,image/png"
            onChange={handleFileChange}
            className="hidden"
          />
          <p className="text-sm mt-2">Drag your image here</p>
          <em className="text-xs text-gray-400">
            (Only *.jpeg and *.png images will be accepted)
          </em>
        </label>
      </div>
      {/* image preview */}
    </div>
  );
};

export default Uploader;
